import { refreshS1CookieAfterOpix } from '@/utils/tracking/s1Cookie'
import { useMainStore } from '@/store'

// issue #822: OpenPixelの s1 をサーバ発行のCookieに置き換える。
//
// OpenPixelが s1 を書き直すのは本体JSの読み込み時(=ページ読み込み時)のみなので、
// router.afterEach では呼ばず、ページ読み込みごとに1回だけ実行する。
export default defineNuxtPlugin(() => {
  refreshS1CookieAfterOpix(useMainStore())
})
